import { FC, PropsWithChildren } from "react";
import { useTranslation } from "react-i18next";
import useEvent from "react-use-event-hook";
import { useRecoilState } from "recoil";

import {
  MODAL_DIALOG_FILL_CONTENT_HEIGHT_CLASS,
  ModalDialog,
} from "@ryde/controls";
import { profileModalOpenStateAtom } from "@ryde/shared";

import { ProfileModalContent } from "./profile.modal.content";

interface IProfileScopeContent extends PropsWithChildren {
  show?: boolean;
}

export const ProfileScopeModalContainer: FC<IProfileScopeContent> = () => {
  const { t } = useTranslation();
  const [isProfileModalOpen, setProfileModalOpenState] = useRecoilState(
    profileModalOpenStateAtom,
  );
  const closeProfileScopeModal = useEvent(() => {
    setProfileModalOpenState(false);
  });

  return (
    <>
      {isProfileModalOpen && (
        <ModalDialog
          title={t(`general.CHOOSE_COMPANY_PROFILE`)}
          closeModalClick={closeProfileScopeModal}
          closeButtonTitle={"Close"}
          isModalOpen={isProfileModalOpen}
          showFooter={false}
          shouldAnimateEntry
          containerClassName={MODAL_DIALOG_FILL_CONTENT_HEIGHT_CLASS}
        >
          <ProfileModalContent />
        </ModalDialog>
      )}
    </>
  );
};
